/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html'
})
export class Page404Component implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
